export const PAINTS_SET_ORDER_VALUE = 'PAINTS_SET_ORDER_VALUE';
export const PAINTS_SET_INIT = 'PAINTS_SET_INIT';
export const PAINTS_ADD_SKIPPED = 'PAINTS_ADD_SKIPPED';
export const PAINTS_REMOVE_SKIPPED = 'PAINTS_REMOVE_SKIPPED';
export const PAINTS_HANDLE_OTHER = 'PAINTS_HANDLE_OTHER';
export const PAINTS_CLEAR = 'PAINTS_CLEAR';
export const PAINTS_ADD_ORDERS = 'PAINTS_ADD_ORDERS';
